export default __webpack_public_path__ + "static/media/VABCA.2d312724.jpg";